// src/components/shared/CategoryNav.js
import React, { useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../../lib/AppContext';
import { t } from '../../lib/i18n';

const CATEGORIES = [
  { id: 'new-arrivals', icon: '⭐', key: 'new_arrivals' },
  { id: 'cbd-flower',   icon: '🌿', key: 'cbd_flower' },
  { id: 'hemp-resin',   icon: '🧱', key: 'hemp_resin' },
  { id: 'vapes-carts',  icon: '💨', key: 'vapes_carts' },
  { id: 'bundles',      icon: '🎁', key: 'bundles' },
];

export default function CategoryNav() {
  const { lang, activeCategory, searchQuery, dispatch } = useApp();
  const ref = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = (catId) => {
    dispatch({ type: 'SET_ACTIVE_CATEGORY', payload: catId });
    const el = document.getElementById(`section-${catId}`);
    if (el) {
      const offset = 88 + 50 + 16; // topnav (88px) + catnav + breathing room
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
    const btn = ref.current?.querySelector(`[data-cat="${catId}"]`);
    if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  const handleSearchChange = (e) => {
    dispatch({ type: 'SET_SEARCH', payload: e.target.value });
  };

  const handleSearchFocus = () => {
    if (pathname !== '/search') navigate('/search');
  };

  const isSearchRoute = pathname === '/search';

  return (
    <>
      {/* Category strip */}
      <div className="catnav">
        <div className="catnav-inner" ref={ref}>
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              data-cat={cat.id}
              onClick={() => handleClick(cat.id)}
              className={`catnav-btn ${activeCategory === cat.id ? 'active' : ''}`}
            >
              <span className="catnav-icon">{cat.icon}</span>
              {t(cat.key, lang)}
            </button>
          ))}
        </div>
      </div>

      {/* Mobile search bar — only shown on /search route (CSS + class gate) */}
      <div className={`mobile-search-bar${isSearchRoute ? ' is-search-route' : ''}`}>
        <div className="mobile-search-bar-wrap">
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            onFocus={handleSearchFocus}
            placeholder={t('search', lang)}
            aria-label={t('search', lang)}
            autoComplete="off"
            // Auto-focus when the search bar appears on mobile
            ref={el => { if (el && isSearchRoute) el.focus(); }}
          />
        </div>
      </div>
    </>
  );
}